import { Tag, Typography } from "antd";
import { dateFormat } from "../../core/utils/date-utils";
import { RE_ASSESSMENT_RESULT, reAssessmentResultKey } from "../../enums/ReAssessmentEnums";

const ellipsis = (width) => (text) => (
    <Typography.Text ellipsis={{ tooltip: text }} style={{ width }}>
        {text || '-'}
    </Typography.Text>
);

const outcomeColor = (outcome) => ({
    [RE_ASSESSMENT_RESULT.CHANGED]: 'red',
    [RE_ASSESSMENT_RESULT.UNCHANGED]: 'green',
    [RE_ASSESSMENT_RESULT.OPEN]: 'orange',
}[outcome] || 'default');

/**
 * Yeniden değerlendirme listesinin kolonları.
 *
 * columnName = SIRALAMA için StudyTask entity'si üzerindeki özellik yolu (sunucu bu yolu doğrudan
 * ifadeye çeviriyor). Sonuç kolonu description metninden TÜRETİLDİĞİ için sıralanabilir değildir.
 */
export default function reAssessmentColumns(t) {
    return [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            columnName: 'id',
            sorter: true,
            width: 90,
        },
        {
            title: t('Re-Assessment Result'),
            dataIndex: 'outcome',
            key: 'outcome',
            width: 150,
            render: (value) => <Tag color={outcomeColor(value)}>{t(reAssessmentResultKey(value))}</Tag>
        },
        {
            title: t('Original Read User'),
            dataIndex: 'originalReadUserName',
            key: 'originalReadUserName',
            columnName: 'originalReadUser.visibleName',
            sorter: true,
            width: 180,
            render: ellipsis(170),
        },
        {
            title: t('Patient Name'),
            dataIndex: 'patientName',
            key: 'patientName',
            columnName: 'study.patient.name',
            sorter: true,
            width: 180,
            render: ellipsis(170),
        },
        {
            title: t('Accession Number'),
            dataIndex: 'accessionNumber',
            key: 'accessionNumber',
            width: 150,
            render: ellipsis(140),
        },
        {
            title: t('Hospital'),
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            columnName: 'study.pacsSystem.hospital.name',
            sorter: true,
            width: 160,
            render: ellipsis(150),
        },
        {
            title: t('Modality'),
            dataIndex: 'modality',
            key: 'modality',
            width: 90,
        },
        {
            title: t('Request'),
            dataIndex: 'requestName',
            key: 'requestName',
            width: 160,
            render: ellipsis(150),
        },
        {
            title: t('Study Date'),
            dataIndex: 'studyDate',
            key: 'studyDate',
            columnName: 'study.studyDateTime',
            sorter: true,
            width: 130,
            render: (text) => (text ? dateFormat(text) : '-')
        },
        {
            title: t('Report Date'),
            dataIndex: 'reportDate',
            key: 'reportDate',
            width: 130,
            render: (text) => (text ? dateFormat(text) : '-')
        },
        {
            title: t('Re-Assessment Reason'),
            dataIndex: 'reason',
            key: 'reason',
            width: 220,
            render: ellipsis(210),
        },
        {
            title: t('Requested By'),
            dataIndex: 'createdUserName',
            key: 'createdUserName',
            columnName: 'createdUser.visibleName',
            sorter: true,
            width: 170,
            render: ellipsis(160),
        },
        {
            title: t('Assigned Doctor'),
            dataIndex: 'assignedUserName',
            key: 'assignedUserName',
            columnName: 'user.visibleName',
            sorter: true,
            width: 170,
            render: ellipsis(160),
        },
        {
            title: t('Requested At'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            columnName: 'createdAt',
            sorter: true,
            width: 140,
            render: (text) => (text ? dateFormat(text) : '-')
        },
        {
            title: t('Resolved By'),
            dataIndex: 'resolvedByUserName',
            key: 'resolvedByUserName',
            width: 170,
            render: ellipsis(160),
        },
        {
            title: t('Resolved At'),
            dataIndex: 'resolvedAt',
            key: 'resolvedAt',
            width: 140,
            render: (text) => (text ? dateFormat(text) : '-')
        },
    ];
}
